import { MIGALHA } from '../actions/actionTypes';
import initialState from './initialState';

export default function migalhaReducer(state = initialState.migalha, action) {
    if (action.type === MIGALHA) {
        return action.migalha;
    }
    return state;
}
